import http from "./http";
const head = "https://airdrop.web3pvz.com/new_battle";
export function pvzwebLoginByWallet(params) {
  return http.get(head + "/pvzwebLoginByWallet", { params, data: params });
}
export function pvzwebAirdropInfo(params) {
  return http.get(head + "/pvzwebAirdropInfo", { params, data: params });
}
export function pvzwebAirdropBuy(params) {
  return http.get(head + "/pvzwebAirdropBuy", { params, data: params });
}
export function pvzwebUserClaimList(params) {
  return http.get(head + "/pvzwebUserClaimList", { params, data: params });
}
// 导出一个名为pvzwebUserClaim的函数，该函数接收一个参数params
export function pvzwebUserClaim(params) {
  // 使用http.get方法发送get请求，请求地址为head + "/pvzwebUserClaim"，请求参数为params，请求体为params
  return http.get(head + "/pvzwebUserClaim", { params, data: params });
}
export function pvzwebUserOrderList(params) {
  return http.get(head + "/pvzwebUserOrderList", { params, data: params });
}
export function fetchKycToken(params) {
  return http.post("https://nest-api.zk.me/api/token/get", params);
}
export function pvzwebUserKycInfo(params) {
  return http.get(head + "pvzwebUserKycInfo", params);
}
